<!-- 走马灯 -->
<template>
<div class='cm_carousel_container'>
   <el-carousel :interval="5000" arrow="hover" height="417px">
    <el-carousel-item v-for="item in dataList" :key="item.NEWS_ID" >
      <span class="cm_carousel_title">{{item.TITLE}}</span>
      <img :src="baseUrl+item.ATTACHMENTPIC" class="cm_carousel_img" @click="toDetail(item.NEWS_ID,data)">
    </el-carousel-item>
  </el-carousel>
</div>
</template>

<script>

export default {
components: {},
props:["data"],
data() {
//这里存放数据
return {
  temData:{},
  dataList:[],
  baseUrl:window.SITE_CONFIG.baseUrl,
  sendData:""
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  toDetail(ID,data){
     this.$router.push({path:'/detail/'+ID,query: {parentData:JSON.stringify(data)}})
  },
  httpPost() {
    this.sendData = this.data.data;
    if(this.data.carouselData) {
        this.sendData = this.data.carouselData;
    }
    // if(this.data.carouselData!=""&&this.data.carouselData!=undefined&&this.data.carouselData!=null){
    //   this.sendData = this.data.carouselData
    // }else{
    //   this.sendData = this.data.data
    // }
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: 'post',
        data: this.sendData
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.dataList = data.data.pdList
        }
      });
    },

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.httpPost()
},

}
</script>
<style scoped>
.cm_carousel_img{
  width: 100%;
  height:100%;
  cursor:pointer;
}
.cm_carousel_container{
  width:628px;
  }
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  .cm_carousel_title{
    display: inline;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-items: center;
    padding:10px;
    color:#fff;
    background: #000000;
    opacity: 0.4;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>